import { Icon } from '@gitbook/spine-icons';

export const SiteVariantIcon = Icon.Browser;
